module.exports = __webpack_public_path__ + "img/head-shoulders_active.d729a7e0.png";